import { useCallback, useState } from 'react';
import { stanAnalytics } from '@/lib';
import { useUser } from '@/queries/useUser';
import { useAskStanleyStore } from '@/stores/askStanleyStore';
import { useIsMobile } from '@/hooks/useMediaQuery';

export const useImagePreview = () => {
    const [isImagePreviewOpen, setIsImagePreviewOpen] = useState(false);
    const [previewImageSrc, setPreviewImageSrc] = useState('');
    const [previewImageAlt, setPreviewImageAlt] = useState('');
    const [previewImageFilename, setPreviewImageFilename] = useState('');
    const { user } = useUser();
    const currentChatId = useAskStanleyStore(state => state.currentChatId);
    const isMobile = useIsMobile();

    const handlePreviewImage = useCallback(
        (file: File) => {
            // Track image view event
            stanAnalytics('chat-v2-image-viewed', {
                meta: { user_id: user?.user_id, username: user?.username },
                props: {
                    chat_id: currentChatId,
                    platform: isMobile ? 'mobile' : 'desktop',
                },
            });

            const imageUrl = URL.createObjectURL(file);
            setPreviewImageSrc(imageUrl);
            setPreviewImageAlt(file.name);
            setPreviewImageFilename(file.name);
            setIsImagePreviewOpen(true);
        },
        [user, currentChatId, isMobile]
    );

    const handleCloseImagePreview = useCallback(() => {
        setIsImagePreviewOpen(false);
        if (previewImageSrc) {
            URL.revokeObjectURL(previewImageSrc);
        }
        setPreviewImageSrc('');
        setPreviewImageAlt('');
        setPreviewImageFilename('');
    }, [previewImageSrc]);

    return {
        isImagePreviewOpen,
        previewImageSrc,
        previewImageAlt,
        previewImageFilename,
        handlePreviewImage,
        handleCloseImagePreview,
    };
};
